import script from "./NftConstructorBgGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./NftConstructorBgGallery.vue?vue&type=script&setup=true&lang=js"

import "./NftConstructorBgGallery.vue?vue&type=style&index=0&id=46e026d8&lang=scss"

const __exports__ = script;

export default __exports__